export default {
  setServerList(state, value) {
    state.serverList = value
  },
  setCheckServerItem(state, value) {
    state.selectServerItem = value
  },
  setNickName(state, value) {
    state.nickName = value
  },
  setUserId(state, value) {
    state.userId = value
  },
  setServerUserId(state, value) {
    state.serverUserId = { value, t: Date.now() }
  },
  setPublicSkuList(state, value) {
    state.publicSkuList = value
  },
  setCheckSkuItem(state, value) {
    state.selectSkuItem = value
  },
  setChekOuterSkuItem(state, value) {
    state.selectOuterSkuItem = value
  },
  setPayList(state, value) {
    state.payList = value
  },
  setCouponData(state, value) {
    state.couponData = value
  },
  setCheckGokSkuids(state, value) {
    state.selectGokSkuids = value
  },
  setAccountId(state, value) {
    state.accountId = value
  },
  setUserRoles(state, value) {
    state.userRoles = value
  },
  setIsTipsOpen(state, value) {
    state.isTipsOpen = value
  },
  setIsVpns(state, value) {
    state._isVpns = value
  },
  setDetailBasicConfig(state, value) {
    state.detailBasicConfig = value
  },
  setTuneUpLogin(state, value) {
    state.tuneUpLogin = value
  },
  setIsSaveCoupon(state, value) {
    state.isSaveCoupon = value
  },
  setCoupons(state, value) {
    state.coupons = value
  },
  setServerId(state, value) {
    state.serverId = value
  },
  setUidFocus(state, value) {
    state.isUidFocus = value
  },
  setCouponUplogin(state, value) {
    state.couponUplogin = value
  },
  setPaymentChannel(state, value) {
    state.paymentChannel = value
  },
  setCheckChannelItem(state, value) {
    state.selectChannelItem = value
  },
  setDiscountMoney(state, value) {
    state.discountMoney = value
  },
  setSubmitCloudControl(state, value) {
    state.submitCloudControl = value
  },
  setSubmitClickStatus(state, value) {
    state.submitClickStatus = value
  },
  setIsPierceLogoLayer(state, value) {
    state.isPierceLogoLayer = value
  },
  setAPPnoReloadPage(state, value) {
    state._noReloadPage = value
  },
  setCalfinalPrice(state, value) {
    state.calfinalPrice = value
  },
  setLoadingBySkuChannels(state, { key, value }) {
    state.loadingBySkuChannels[key] = value
  },
  setRenderPcNav(state, value) {
    state.isRender900Nav = value
  },
  setToggleCouponLoging(state, value) {
    state.toggleCouponLoging = value
  },
  setCouponDiscountMoney(state, value) {
    state.couponDiscountMoney = value
  },
  setUidValidator(state, value) {
    state.uidValidator = { ...state.uidValidator, ...value }
  },
  setExeOrderMethod(state, value) {
    state.exeOrderMethod = value
  },
  setSubmitButtonState(state, value) {
    state.submitButtonState = value
  },
  setCreateCouponrState(state, value) {
    state.createCouponrState = value
  },
  setPayChanState(state, value) {
    state.payStatus = value
  },
  setIkCpServerId(state, value) {
    state.ikCpServerId = value
  },
  setCheckffuid(state, value) {
    state.checkffuid = value
  },
  setRenderCheckffuid(state, value) {
    state.isRenderCheckffuid = value
  },
  setOperateLayer(state, popupId) {
    state.operateLayer = { popupId, t: Date.now() }
  },
  setShowDiscount(state, value) {
    state.isShowDiscount = value
  },
  setGameConfig(state, value) {
    state.ssrConfig = value
  },
  setSsrAllData(state, value) {
    state.ssrAllData = value
  },
  setNotificationEmail(state, value) {
    state.notificationEmail = value
  },
}
